import { object, string, boolean } from 'yup';
import i18n from 'config/i18n';

const MIN_PASSWORD_CHARS = 6;

const invalidEmail: string = i18n.t('auth:invalidEmail');
const required: string = i18n.t('common:required');
const acceptTermsError: string = i18n.t('auth:acceptTermsError');
const passwordLength: string = i18n.t('auth:passwordLength', { count: MIN_PASSWORD_CHARS });

const openSignUpEmail = () => {
  return string().required(required).email(invalidEmail);
};

export interface ISignInValues {
  username: string;
  password: string;
}

export interface ISignUpValues {
  username: string;
  password: string;
  acceptTerms: boolean;
}

export interface IForgotPasswordSendValues {
  username: string;
}

export interface IForgotPasswordSubmitValues {
  code: string;
  password: string;
}

export interface INewPasswordValues {
  password: string;
}

export interface IConfirmSignUpValues {
  code: string;
}

export interface IClientRedirectSchema {
  username: string;
}

const SignInSchema = object().shape({
  username: string().required(required).email(invalidEmail),
  password: string().min(MIN_PASSWORD_CHARS, passwordLength).required(required),
});

const SignUpSchema = () => {
  return object().shape({
    username: openSignUpEmail(),
    password: string().min(MIN_PASSWORD_CHARS, passwordLength).required(required),
    acceptTerms: boolean().oneOf([true], acceptTermsError),
  });
};

const ForgotPasswordSendSchema = object().shape({
  username: string().required(required).email(invalidEmail),
});

const ForgotPasswordSubmitSchema = object().shape({
  code: string().required(required),
  password: string().min(MIN_PASSWORD_CHARS, passwordLength).required(required),
});

const NewPasswordSchema = object().shape({
  password: string().min(MIN_PASSWORD_CHARS, passwordLength).required(required),
});

const ConfirmSignUpSchema = object().shape({
  code: string().required(required),
});

const ClientRedirectSchema = object().shape({
  username: string().required(required).email(invalidEmail),
});

export {
  ClientRedirectSchema,
  SignInSchema,
  SignUpSchema,
  ForgotPasswordSendSchema,
  ForgotPasswordSubmitSchema,
  ConfirmSignUpSchema,
  NewPasswordSchema,
};
